"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Search, ShieldCheck, SprayCan, ClipboardCheck, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
const steps = [{
  id: "01",
  title: "المعاينة والفحص",
  description: "نقوم بفحص شامل للموقع لتحديد نوع الحشرات وأماكن تركزها بدقة عالية باستخدام تقنيات حديثة.",
  icon: Search,
  className: "md:col-span-2"
}, {
  id: "02",
  title: "خطة المكافحة",
  description: "وضع استراتيجية مخصصة باستخدام أفضل المبيدات الآمنة والفعالة.",
  icon: ShieldCheck,
  className: "md:col-span-1"
}, {
  id: "03",
  title: "التنفيذ والرش",
  description: "تطبيق عمليات الرش والمكافحة بأحدث المعدات لضمان القضاء التام.",
  icon: SprayCan,
  className: "md:col-span-1"
}, {
  id: "04",
  title: "المتابعة الدورية",
  description: "زيارات تفقدية لضمان عدم عودة الحشرات والحفاظ على بيئة صحية مستدامة.",
  icon: ClipboardCheck,
  className: "md:col-span-2"
}];
export default function StepByStepInnovation() {
  return <section data-section-id="223713" id="خطوات-العمل" className="text-foreground py-24 relative overflow-hidden" style={{
    backgroundColor: 'var(--primary)'
  }} dir="rtl">
      {}
      <div className="absolute top-0 right-0 w-full h-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661713/img/pest_control_pattern.png)] opacity-5 pointer-events-none" />
      <div className="absolute bottom-[-20%] sm:bottom-[-15%] lg:bottom-[-24px] -left-[30%] sm:-left-[20%] lg:-left-24 w-96 h-96 blur-[100px] rounded-full pointer-events-none" style={{
      backgroundColor: 'color-mix(in srgb, var(--accent), transparent 90%)'
    }} />

      <div className="container mx-auto px-4 sm:px-6 md:px-8 relative z-10 max-w-7xl">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
          <div className="text-right">
            <span className="inline-block px-4 py-1 rounded-full text-sm font-bold mb-4 border" style={{
            backgroundColor: 'color-mix(in srgb, var(--accent), transparent 90%)',
            color: 'var(--accent)',
            borderColor: 'color-mix(in srgb, var(--accent), transparent 80%)'
          }}>
              منهجية العمل
            </span>
            <h2 className="font-default text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight" style={{
            color: 'var(--text-light)'
          }}>
              كيف نضمن لك <span style={{
              color: 'var(--accent)'
            }}>بيئة خالية</span> من الآفات؟
            </h2>
          </div>
          <p className="max-w-md text-lg font-default leading-relaxed" style={{
          color: 'color-mix(in srgb, var(--text-light), transparent 30%)'
        }}>
            نتبع في سرايا بروتوكولات عالمية تبدأ من التشخيص الدقيق وتنتهي بالمتابعة المستمرة لضمان راحة بالك.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5 lg:gap-6 mb-16">
          {steps.map((step, i) => {
          const Icon = step.icon;
          return <Card key={step.id} data-index={i} className={`group relative backdrop-blur-xl transition-all duration-500 rounded-lg overflow-hidden ${step.className}`} style={{
            backgroundColor: 'color-mix(in srgb, var(--secondary), transparent 60%)',
            borderColor: 'color-mix(in srgb, var(--text-light), transparent 90%)'
          }}>
                <div className="absolute top-0 left-0 w-full h-1 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{
              background: 'linear-gradient(to left, transparent, color-mix(in srgb, var(--accent), transparent 50%), transparent)'
            }} />
                
                <CardHeader className="relative z-10 pt-8">
                  <div className="flex items-start justify-between">
                    <div className="p-4 rounded-lg border group-hover:scale-110 transition-transform duration-300 shadow-sm" style={{
                  backgroundColor: 'var(--accent)',
                  borderColor: 'color-mix(in srgb, var(--text-light), transparent 90%)'
                }}>
                      <Icon className="w-10 h-10" style={{
                    color: 'var(--text-dark)'
                  }} strokeWidth={1.5} />
                    </div>
                    <span className="text-4xl font-bold transition-colors duration-500" style={{
                  color: 'color-mix(in srgb, var(--text-light), transparent 95%)'
                }}>
                      {step.id}
                    </span>
                  </div>
                  <CardTitle className="font-default font-bold text-2xl mt-6" style={{
                color: 'var(--text-light)'
              }}>
                    {step.title}
                  </CardTitle>
                </CardHeader>
                
                <CardContent className="relative z-10 pb-8">
                  <p className="text-lg leading-relaxed font-default" style={{
                color: 'color-mix(in srgb, var(--text-light), transparent 40%)'
              }}>
                    {step.description}
                  </p>
                </CardContent>

                {}
                <div className="absolute -bottom-12 -right-12 w-32 h-32 blur-3xl rounded-full transition-colors duration-500" style={{
              backgroundColor: 'color-mix(in srgb, var(--accent), transparent 95%)'
            }} />
              </Card>;
        })}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          {}
          <div className="lg:col-span-7 p-8 rounded-lg border backdrop-blur-sm shadow-lg" style={{
          backgroundColor: 'color-mix(in srgb, var(--secondary), transparent 70%)',
          borderColor: 'color-mix(in srgb, var(--text-light), transparent 95%)'
        }}>
            <div className="flex justify-between items-end mb-6">
              <div className="flex flex-col text-right">
                <span className="text-xs font-default font-bold uppercase tracking-widest mb-2" style={{
                color: 'var(--accent)'
              }}>مؤشرات الأداء</span>
                <h3 className="font-default font-bold text-xl" style={{
                color: 'var(--text-light)'
              }}>نسبة نجاح عمليات الإبادة النهائية</h3>
              </div>
              <div className="text-right">
                <span className="font-default font-bold text-3xl" style={{
                color: 'var(--accent)'
              }}>98%</span>
                <p className="text-xs" style={{
                color: 'color-mix(in srgb, var(--text-light), transparent 60%)'
              }}>بناءً على تقييمات 2023</p>
              </div>
            </div>
            <Progress value={98} className="h-2" style={{
            backgroundColor: 'color-mix(in srgb, var(--text-light), transparent 95%)'
          }} />
            <div className="mt-6 flex gap-4">
              <div className="flex items-center gap-2 text-sm" style={{
              color: 'color-mix(in srgb, var(--text-light), transparent 40%)'
            }}>
                <div className="w-2 h-2 rounded-full" style={{
                backgroundColor: 'var(--accent)'
              }} />
                <span>مبيدات معتمدة</span>
              </div>
              <div className="flex items-center gap-2 text-sm" style={{
              color: 'color-mix(in srgb, var(--text-light), transparent 40%)'
            }}>
                <div className="w-2 h-2 rounded-full" style={{
                backgroundColor: 'var(--accent)'
              }} />
                <span>ضمان حقيقي</span>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 flex flex-col items-center lg:items-start gap-6">
            <p className="text-center lg:text-right font-default text-lg" style={{
            color: 'color-mix(in srgb, var(--text-light), transparent 20%)'
          }}>
              هل أنت مستعد لتأمين منزلك؟ ابدأ رحلة الحماية اليوم مع خبراء سرايا.
            </p>
            <Link to="https://wa.me/966505276652" newTab className="flex items-center gap-3 border px-8 py-4 rounded-lg transition-all duration-300 group" style={{
            backgroundColor: 'color-mix(in srgb, var(--text-light), transparent 95%)',
            borderColor: 'color-mix(in srgb, var(--text-light), transparent 90%)'
          }}>
              <Phone className="w-6 h-6 group-hover:scale-110 transition-transform" style={{
              color: 'var(--accent)'
            }} />
              <span className="text-2xl font-bold font-default tracking-wider" style={{
              color: 'var(--accent)'
            }} dir="ltr">
                0505276652
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}